import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { QueryService } from '../../comun/services/query.service';
import { GlobalConstants } from '../../global-constants';

@Component({
  selector: 'app-regenerate',
  templateUrl: './regenerate.component.html',
  styleUrl: './regenerate.component.css'
})
export class RegenerateComponent {
  userId: string | null = null;
  token: string | null = null;
  form: FormGroup;
  error: string = '';
  aviso: string = '';
  busy: boolean = false;
  global: any = GlobalConstants;
  backgroundImage = GlobalConstants.urlServer + '/img/perro-portatil.png';
  regenerate: boolean = false;
  showPassword: boolean = false;

  constructor(private fb: FormBuilder,
              private query: QueryService)
  {
    this.form = this.fb.group({
      password: ['', Validators.required],
      passwordconf: ['', Validators.required],
    });
  }

  ngOnInit() {
    // Usamos el API nativo de JavaScript para leer la URL del navegador
    const urlParams = new URLSearchParams(window.location.search);
    
    this.userId = urlParams.get('id');
    this.token = urlParams.get('token');
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  regenerarPassword() {
    this.busy = true;
    const formData = this.form.value;
    this.query.query('restablecer_password', null, { id: this.userId, token: this.token, password: formData.password, passwordconf: formData.passwordconf }).subscribe((resultado:any) => {
      if (resultado.resultado == 'ERROR')
        this.error = resultado.mensaje;
      else if (resultado.resultado == 'OK')
        this.aviso = resultado.mensaje;
      this.busy = false;
    });
  }

  acceder() {
    window.location.href = GlobalConstants.urlServer + 'login';
  }

}
